// custom vue directives
import type { Directive } from "vue"

type ClickOutsideEl = HTMLElement & { clickOutsideEvent?: (event: MouseEvent) => void }

export const clickOutside: Directive<ClickOutsideEl, (event: MouseEvent, el: HTMLElement) => void> =
  {
    mounted(el, binding) {
      el.clickOutsideEvent = function (event) {
        if (!(el === event.target || el.contains(event.target as Node | null))) {
          binding.value(event, el)
        }
      }
      document.body.addEventListener("click", el.clickOutsideEvent)
    },
    unmounted(el) {
      if (el.clickOutsideEvent) document.body.removeEventListener("click", el.clickOutsideEvent)
    },
  }
